export const PageHeader = ({ eyebrow, title, subtitle, children, testId }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-6 lg:mb-8 fade-up">
    <div className="min-w-0">
      {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight" data-testid={testId || "page-title"}>{title}</h1>
      {subtitle && <p className="text-sm sm:text-base text-muted-foreground mt-1.5">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const EmptyState = ({ text, testId, icon: Icon }) => (
  <div className="flex flex-col items-center justify-center text-center py-10 px-4 text-muted-foreground" data-testid={testId}>
    {Icon && <Icon className="h-8 w-8 mb-3 opacity-50" />}
    <p className="text-sm font-medium">{text}</p>
  </div>
);

export const FormError = ({ message, testId }) =>
  message ? (
    <div role="alert" className="rounded-xl border border-rose-200 bg-rose-50 text-rose-800 px-3.5 py-2.5 text-sm font-medium" data-testid={testId}>
      {message}
    </div>
  ) : null;

const STATUS = {
  approaching: { label: "Approaching budget", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  over: { label: "Over budget", cls: "bg-rose-100 text-rose-800 border-rose-300" },
  ok: { label: "On track", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  none: { label: "No budget set", cls: "bg-secondary text-muted-foreground border-border" },
};

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.none;
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${s.cls}`} data-testid={testId}>
      {s.label}
    </span>
  );
};

export const ProgressBar = ({ percent, status }) => {
  const color = status === "over" ? "bg-rose-500" : status === "approaching" ? "bg-amber-500" : "bg-emerald-500";
  return (
    <div className="h-2 w-full rounded-full bg-secondary overflow-hidden">
      <div className={`h-full rounded-full ${color} transition-[width] duration-500`} style={{ width: `${Math.min(percent || 0, 100)}%` }} />
    </div>
  );
};
